import { DestinationItemType } from '@tableau/nested-project-explorer';

import {SessionSiteSelectors} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import {getAppStore} from '~src/bootstrap/redux/store/AppStore';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { CommonErrorCode, ContentErrorCode,FlowErrorCode, TagErrorCode } from '~src/commonInfra/utils/ErrorCodes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Formatters, Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { L10n } from '../../commonInfra/L10n/L10n';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { FlowContentType } from '../../spacesPlatform/models/ContentTypes';
import { FlowBaseInfo } from '../models/FlowInfo';

type FlowErrorInfo = {
  readonly flowName?: string;
  readonly errorCode: number;
}

export namespace FlowErrors {
  export function errorDetailsFor(flowErrorItem: IErrorItem<FlowBaseInfo>, destinationItemType?: DestinationItemType): IErrorDetail {
    const flowErrorInfo: FlowErrorInfo = {
      flowName: flowErrorItem.item.name,
      errorCode: flowErrorItem.error.code
    };
    return {
      itemName: flowErrorItem.item.name,
      itemUrl:
        flowErrorItem.error.code === CommonErrorCode.FlowNotFound
          ? null
          : ContentUrlForItem(flowErrorItem.item, FlowContentType),
      errorMessage: this.errorMessageFor(flowErrorInfo, destinationItemType)
    };
  }

  export function errorMessageFor(errorItem: FlowErrorInfo, destinationType: DestinationItemType, noDefault?: boolean) {
    switch (errorItem.errorCode) {
      case FlowErrorCode.FlowParametersDisabledOnSite:
        return Messages.flowParametersDisabledOnSite();
      case FlowErrorCode.FlowParametersAnyTypeDisabledOnSite:
        return Messages.flowParametersAnyTypeDisabledOnSite();
      case FlowErrorCode.FlowParameterOverrideInvalid:
        return Messages.flowParametersOverrideInvalidError();
      case FlowErrorCode.FlowParameterOverrideMissing:
        return Messages.flowParametersOverrideMissingError();
      case CommonErrorCode.CallingUserInsufficientPermissions:
      case FlowErrorCode.FlowMoveInsufficientPermissionsOnDestinationProject:
        return Messages.errorFlowInsufficientPermissions();
      case FlowErrorCode.FlowChangeOwnerToNotCurrentUser:
        return Messages.errorFlowChangeOwnerToNotCurrentUser();
      case CommonErrorCode.FlowNotFound:
        return Messages.errorFlowNotFound({ FLOW_NAME: L10n.elideIfLong(errorItem.flowName || '') });
      case FlowErrorCode.FlowWithSameNameInDestinationProject:
        return destinationType === DestinationItemType.personalSpace ?
          Messages.errorContentNameAlreadyExistsInPersonalSpace({CONTENT_TYPE: L10n.elideIfLong(FlowContentType.name)}) :
          Messages.errorContentNameAlreadyExistsInDestinationProject({CONTENT_TYPE: L10n.elideIfLong(FlowContentType.name)});
      case FlowErrorCode.FlowNameAlreadyExists:
        return Messages.errorFlowNameAlreadyExists();
      case FlowErrorCode.FlowDestinationProjectNotFound:
        return Messages.errorFlowDestinationProjectNotFound();
      case ContentErrorCode.INVALID_CONTENT_TYPE:
          return Messages.moveContentToPersonalSpaceErrorDetail({CONTENT_TYPE: Messages.flows()});
      case FlowErrorCode.FlowDescriptionTooLong:
        const sessionManagementService = getSessionManagementServiceInstance();
        return Messages.errorFlowDescriptionTooLong({ MAX_LENGTH: Formatters.formatCount(sessionManagementService.maxDescriptionLength()) });
      case CommonErrorCode.JobBulked:
        return Messages.errorFlowJobBulked();
      case TagErrorCode.TooManyTags:
        return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
      case FlowErrorCode.FlowDraftChangeOwner:
        return Messages.changeOwnerFlowDraftError();
      case CommonErrorCode.IncompatibleDocumentVersion:
        return Messages.flowOverviewIncompatibleDocumentVersionWarningLine1({SERVER_VERSION: HelpService.externalVersion()});
        default:
      if (!noDefault) {
        return Messages.errorUnknown();
      }
    }
  }
}
